import { NgModule } from '@angular/core';
import { FbqGgCategoryPageEventBuilder } from './fbq-gg-category-page-event.builder';

@NgModule({})
export class FbqGgCategoryPageEventModule {
  constructor(_fbqGgCategoryPageEventBuilder: FbqGgCategoryPageEventBuilder) {}
}
